import { useSubscription } from '@apollo/client';
import { CrewChangeActionType, CrewChangeRequestPayload } from '@bechtel/types';
import { useEffect, useState } from 'react';
import { SUBSCRIPTION_CREW_CHANGE_REQUEST_ACTION } from '@bechtel/client-gql';
import { useCrewChangeCache } from '~/hooks/use-crew-change-cache';
import { USER_PROJECT_ID } from '@bechtel/client-common';

export function useCrewChangeSubscription() {
  const { data } = useSubscription<{ crewChangeRequest: CrewChangeRequestPayload }>(
    SUBSCRIPTION_CREW_CHANGE_REQUEST_ACTION
  );
  const { updateCrewChangeRequestCache } = useCrewChangeCache();
  const response = useState('');
  const setCrewChangeRequestId = response[1];
  const currentUserSelectedProject = window.sessionStorage.getItem(USER_PROJECT_ID);

  useEffect(() => {
    if (
      !data ||
      !data.crewChangeRequest ||
      !data.crewChangeRequest.projectId ||
      !currentUserSelectedProject ||
      data.crewChangeRequest.projectId !== currentUserSelectedProject ||
      !data.crewChangeRequest.crewChangeRequestIds ||
      data.crewChangeRequest.crewChangeRequestIds.length == 0
    )
      return;
    if (data.crewChangeRequest.crewChangeActionType == CrewChangeActionType.CREATED)
      setCrewChangeRequestId(data.crewChangeRequest.crewChangeRequestIds[0]);
    else {
      updateCrewChangeRequestCache(data.crewChangeRequest.crewChangeRequestIds);
      setCrewChangeRequestId('');
    }
  }, [data]);

  return response;
}
